export default {
  // HTwbCardHome.vue 字符串
  title: "HTcard",
  login: "登录",
  logout: "登出",
  
  // 搜索相关
  searchPlaceholder: "搜索收集板标题...",
  clearSearch: "清除搜索",
  searching: "搜索中...",
  searchResults: "找到 {count} 个结果",
  
  // 收集板相关
  addCollectBoard: "新增收集板\n(CardCollect)",
  collectBoardStatus: {
    openSubmit: "开放提交",
    closeSubmit: "关闭提交"
  },
  
  // 未登录状态
  welcome: {
    title: "欢迎使用 HTcard",
    message: "请先登录以开始使用卡片收集功能"
  },
  
  // Modal 标题
  modals: {
    createTitle: "新增收集板",
    editTitle: "更新收集板设置",
    deleteTitle: "确认删除收集板"
  },
  
  // 表单
  forms: {
    collectBoardName: "请输入收集板名称",
    openSubmitLabel: "开放提交",
    cancel: "取消",
    create: "创建",
    update: "更新",
    delete: "删除",
    setting: "设置"
  },
  
  // 删除确认
  deleteConfirm: {
    message: "确定要删除收集板「{name}」吗？",
    warning: "警告：此操作将会删除收集板内的所有卡片及其文件，无法恢复，请谨慎确认！",
    deleting: "删除中...",
    confirmDelete: "确认删除"
  },
  
  // 消息提示  
  messages: {
    loginSuccess: "登录成功！",
    loginFailed: "登录失败",
    logoutSuccess: "登出成功",
    logoutFailed: "登出失败",
    loadFailed: "载入失败",
    createSuccess: "创建成功！",
    createFailed: "创建失败",
    updateSuccess: "更新成功！",
    updateFailed: "更新失败",
    deleteSuccess: "收集板删除成功！",
    deleteFailed: "删除失败，请稍后再试",
    searchFailed: "搜索失败，请稍后再试",
    alreadyCopied: "已复制到剪贴板"
  },

  // HTwbCardCollect.vue 字符串
  collect: {
    loading: "载入中...",
    loadFailed: "载入失败",
    
    // 搜索
    searchCardPlaceholder: "搜索卡片名称或创建者...",
    searchResultsCount: "找到 {count} 个结果",
    
    // 颜色筛选
    colorFilter: "颜色筛选",
    colorTitle: "色彩",
    clearFilter: "清除",
    colors: {
      white: "白色",
      lightYellow: "浅黄",
      lightGreen: "浅绿",
      lightBlue: "浅蓝", 
      lightPink: "浅粉"
    },
    
    // 按钮
    uploadCard: "上传新卡片",
    addGroup: "新增分组",
    share: "共用",
    shareCard: "分享卡片收藏集",

    // 媒体播放错误
    videoNotSupported: "您的浏览器不支持视频播放",
    audioNotSupported: "您的浏览器不支持音频播放",
    imageLoadFailed: "图片载入失败",
    
    // 上传卡片 Modal
    uploadModal: {
      title: "上传新卡片",
      cardName: "卡片名称 *",
      cardNamePlaceholder: "请输入卡片名称",
      selectGroup: "选择分组",
      textContent: "文字内容 (可选)",
      textContentPlaceholder: "在这里输入您的文字内容...",
      cardColor: "卡片颜色",
      selectFile: "选择文件 (可选)",
      dragDropFile: "点击选择文件或拖拽文件到此处",
      fileHint: "支持所有文件格式",
      fileSizeHint: "文件大小限制：{size}MB",
      removeFile: "移除文件",
      uploading: "上传中...",
      uploadCard: "上传卡片",
      cancel: "取消"
    },
    
    // 编辑卡片 Modal
    editModal: {
      title: "编辑卡片",
      currentFile: "当前文件：",
      replaceFile: "更换文件",
      removeCurrentFile: "移除当前文件",
      updating: "更新中...",
      confirmUpdate: "确认更新"
    },
    
    // 删除卡片确认
    deleteCardConfirm: {
      title: "确认删除",
      message: "确定要删除卡片「{name}」吗？",
      warning: "此操作无法恢复，将会永久删除卡片及其文件。",
      deleting: "删除中...",
      confirmDelete: "确认删除",
      cancel: "取消"
    },
    
    // 新增分组 Modal
    addGroupModal: {
      title: "新增分组",
      groupName: "分组名称 *",
      groupNamePlaceholder: "请输入分组名称",
      adding: "新增中...",
      confirmAdd: "确认新增",
      cancel: "取消"
    },
    
    // 卡片菜单
    cardMenu: {
      edit: "编辑",
      delete: "删除"
    },
    
    // 默认分组
    defaultGroup: "分组一",
    
    // 文件类型
    fileTypes: {
      unknown: "未知文件",
      image: "图片",
      video: "视频",
      audio: "音频",
      word: "Word文档",
      pdf: "PDF文档",
      text: "文本文件",
      zip: "ZIP压缩文件",
      rar: "RAR压缩文件",
      general: "一般文件",
      textFile: "文本文件",
      applicationFile: "应用程序文件"
    },
    
    // 上传状态
    uploadStatus: {
      preparing: "准备上传...",
      creating: "正在创建卡片记录...",
      uploading: "正在上传文件... ({uploaded}MB / {total}MB)",
      updating: "正在更新卡片信息...",
      saving: "正在保存文字卡片...",
      completed: "上传完成！",
      textCardCreated: "文字卡片创建成功！",
      failed: "上传失败"
    },
    
    // 错误消息
    errors: {
      cardNameRequired: "请输入卡片名称",
      cardNameTooLong: "卡片名称不能超过50个字符",
      contentRequired: "请输入文字内容或选择文件",
      textOrFileRequired: "请输入文字内容或保留/选择文件",
      fileSizeExceeded: "文件大小不能超过 {size}MB",
      groupNameRequired: "请输入分组名称",
      groupNameTooLong: "分组名称不能超过20个字符",
      groupNameExists: "分组名称已存在",
      missingUserInfo: "无法获取用户信息，请刷新页面",
      missingIdInfo: "缺少必要的 ID 信息",
      sasTokenExpired: "SAS Token 已过期，请刷新页面",
      fileUploadFailed: "文件上传失败，请检查网络连接",
      updateDataError: "请求数据有误: {error}",
      cardNotFound: "找不到要更新的卡片",
      noPermission: "没有权限执行此操作",
      authFailed: "认证失败，请刷新页面",
      networkError: "网络错误，请检查连接",
      generalError: "操作失败，请稍后再试",
      copyFailed: "复制失败",
      updateFailed: "更新失败"
    },
    
    // 成功消息
    successMessages: {
      cardUploaded: "卡片上传成功！",
      textCardCreated: "文字卡片创建成功！",
      cardUpdated: "卡片更新成功！",
      cardDeleted: "卡片删除成功！",
      cardMoved: "卡片已移动到新分组",
      groupAdded: "分组新增成功！",
      settingsUpdated: "设置已更新"
    },
    
    // 用户身份
    userIdentity: {
      loggedInUser: "登录用户",
      anonymousUser: "匿名用户",
      systemUser: "系统"
    },
    
    // 留言相关
    comments: {
      placeholder: "输入留言...",
      published: "留言已发布",
      updated: "留言已更新",
      deleted: "留言已删除",
      publishFailed: "发布留言失败",
      updateFailed: "更新留言失败", 
      deleteFailed: "删除留言失败",
      edit: "编辑留言",
      delete: "删除留言",
      justNow: "刚刚",
      minutesAgo: "{minutes}分钟前",
      hoursAgo: "{hours}小时前",
      daysAgo: "{days}天前",
      // 编辑附件相关
      removeAttachment: "移除附件",
      addAttachment: "新增附件",
      replaceAttachment: "更换附件",
      contentRequired: "留言内容或附件不能为空",
      fileTooLarge: "文件 {fileName} 过大（超过 5MB）",
      fileUploaded: "文件 {fileName} 上传成功",
      fileUploadFailed: "文件 {fileName} 上传失败",
      fileProcessFailed: "文件处理失败",
      save: "保存",
      cancel: "取消"
    }
  }
};